import { useQuery } from 'react-query';

import { Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';
import { LoanApplicationTask } from '../../models/LoanApplicationTask';

export function useDealRequiredDocumentsQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.RequiredDocuments.Root(guid),
		() =>
			AxiosUtils.getResponseData<LoanApplicationTask[]>(
				api.get(CerebroApiEndpoints.RequiredDocuments.Root(guid))
			),
		{
			enabled: guid !== undefined,
		}
	);
}
